export default __webpack_public_path__ + "static/media/crime.31a7d844.png";